// App-store links are the same regardless of tenant/environment, so they
// stay here. Support-article "learn more" URLs are tenant-specific
// (built from the consuming app's runtime support base) — each page/step
// accepts those as props instead of hard-coding them.
export const DOWNLOAD_AUTHENTICATOR_APP_APPLE_STORE =
  'https://itunes.apple.com/pt/app/google-authenticator/id388497605?mt=8'
export const DOWNLOAD_AUTHENTICATOR_APP_GOOGLE_PLAY =
  'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2'
